<template>
    <ValidationObserver ref="form" v-slot="{ errors, failed }">
        <div ref="modal" class="modal fade" :id="id" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <form class="modal-content" @submit.prevent="onSubmit">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ isEdit ? 'Update' : 'Create' }} {{ type }}</h5>
                        <button type="button" class="close" data-dismiss="modal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div v-if="isLoading" class="modal-body position-relative" ref="modalBody">
                        <Loader></Loader>
                        <EmptyList :label="'Loading.'"></EmptyList>
                    </div>
                    <div v-else class="modal-body position-relative" ref="modalBody">
                        <div v-if="failed" class="alert alert-danger">
                            <ul class="p-2 m-0">
                                <li v-for="(error, key) in errors" :key="key" v-show="errors[key][0]">
                                    {{ errors[key][0] }}
                                </li>
                            </ul>
                        </div>

                        <div class="d-flex justify-content-center mb-3">
                            <UploadPicker
                                @onUploadImageHandler="onUploadImageQuiz"
                                @onRemoveImageHandler="
                                    ;(quiz.image = null),
                                        (quiz.image_original = null),
                                        (quiz.image_source = null),
                                        (quiz.image_coordinates = null)
                                "
                                @onCropBackground="cropBackground"
                                :path="quiz.image"
                                :image-original="
                                    quiz.image_original && quiz.image_original != '' ? quiz.image_original : quiz.image
                                "
                                :image-source="quiz.image_source"
                                :image-coordinates="quiz.image_coordinates"
                                :quiz-name="'quizMain'"
                                :prompt-title="quiz.title"
                                :location="'quiz'"
                            />
                        </div>
                        <div class="form-group">
                            <label for="title">Title</label>
                            <ValidationProvider name="Title" rules="required" v-slot="{ errors }">
                                <input
                                    v-model="quiz.title"
                                    :class="{ 'form-control': true, 'is-invalid': errors[0] }"
                                    id="title"
                                    placeholder="Enter title"
                                    type="text"
                                />
                                <span class="invalid-feedback">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form-group" v-if="isEdit">
                            <label for="quiz-url">URL</label>
                            <div class="input-group">
                                <input
                                    id="quiz-url"
                                    :value="quiz.url"
                                    class="custom-readonly form-control"
                                    type="text"
                                    readonly
                                />
                                <div class="input-group-append cursor-pointer" @click="openUrlQuiz(quiz.url)">
                                    <span class="input-group-text"> <i class="fas fa-external-link-alt"></i> </span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="d-flex">
                                <label for="description" class="w-100">Description</label>
                                <a
                                    v-if="!isAiGeneratingDescription && quiz.title"
                                    v-tippy="{ placement: 'top' }"
                                    @click="generateAiDescription"
                                    content="Generate description by AI"
                                    href="#"
                                >
                                    <i class="fas fa-robot text-success"></i>
                                </a>
                                <span v-if="isAiGeneratingDescription">
                                    <i class="fas fa-sync fa-spin"></i>
                                </span>
                            </div>
                            <textarea
                                v-model="quiz.description"
                                :disabled="isAiGeneratingDescription"
                                id="description"
                                placeholder="Enter description"
                                class="form-control"
                                type="text"
                            >
                            </textarea>
                        </div>
                        <div class="form-group">
                            <div class="d-flex">
                                <label for="seo_keyword" class="w-100">SEO Keywords</label>
                                <a
                                    v-if="!isAiGeneratingSeoKeyword && quiz.title"
                                    v-tippy="{ placement: 'top' }"
                                    @click="generateAiSeoKeyword"
                                    content="Generate SEO Keyword by AI"
                                    href="#"
                                >
                                    <i class="fas fa-robot text-success"></i>
                                </a>
                                <span v-if="isAiGeneratingSeoKeyword">
                                    <i class="fas fa-sync fa-spin"></i>
                                </span>
                            </div>
                            <textarea
                                v-model="quiz.seo_keyword"
                                :disabled="isAiGeneratingSeoKeyword"
                                id="seo_keyword"
                                placeholder="Enter SEO Keyword"
                                class="form-control"
                                type="text"
                            >
                            </textarea>
                        </div>
                        <div class="form-group">
                            <label for="custom-message">Custom message</label>
                            <input
                                v-model="quiz.custom_message"
                                id="custom-message"
                                placeholder="Enter custom message"
                                class="form-control"
                                type="text"
                            />
                        </div>
                        <div class="form-group">
                            <label>Show number of question</label>
                            <InputNumber v-model="quiz.show_number_question" :min="1" />
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-12 col-md-5">
                                    <SquareIcon
                                        v-if="!quiz.is_random_question_order"
                                        @click="changeRandomQuestion"
                                        class="cursor-pointer"
                                        size="1.5x"
                                    ></SquareIcon>
                                    <CheckSquareIcon
                                        v-if="quiz.is_random_question_order"
                                        @click="changeRandomQuestion"
                                        class="cursor-pointer text-success"
                                        size="1.5x"
                                    ></CheckSquareIcon>
                                    <label class="ml-2 cursor-pointer" @click="changeRandomQuestion">
                                        Random Question
                                    </label>
                                </div>
                                <div v-if="quizType.toLowerCase() !== 'poll'" class="col-12 col-md-5">
                                    <SquareIcon
                                        v-if="!quiz.show_correct_answer"
                                        @click="changeShowCorrectAnswer"
                                        class="cursor-pointer"
                                        size="1.5x"
                                    ></SquareIcon>
                                    <CheckSquareIcon
                                        v-if="quiz.show_correct_answer"
                                        @click="changeShowCorrectAnswer"
                                        class="cursor-pointer text-success"
                                        size="1.5x"
                                    ></CheckSquareIcon>
                                    <label @click="changeShowCorrectAnswer" class="ml-2 cursor-pointer">
                                        Show correct answer when wrong
                                    </label>
                                </div>
                                <div class="col-12 col-md-5">
                                    <SquareIcon
                                        v-if="!quiz.playalone_auto_start"
                                        @click="changePlayaloneAutostart"
                                        class="cursor-pointer"
                                        size="1.5x"
                                    ></SquareIcon>
                                    <CheckSquareIcon
                                        v-if="quiz.playalone_auto_start"
                                        @click="changePlayaloneAutostart"
                                        class="cursor-pointer text-success"
                                        size="1.5x"
                                    ></CheckSquareIcon>
                                    <label @click="changePlayaloneAutostart" class="ml-2 cursor-pointer">
                                        Play Alone Auto-start
                                    </label>
                                </div>
                                <div v-if="quiz.created_by != 'user'" class="col-12 col-md-5">
                                    <SquareIcon
                                        v-if="!quiz.auto_generate"
                                        @click="changeAutoGenerate"
                                        class="cursor-pointer"
                                        size="1.5x"
                                    ></SquareIcon>
                                    <CheckSquareIcon
                                        v-if="quiz.auto_generate"
                                        @click="changeAutoGenerate"
                                        class="cursor-pointer text-success"
                                        size="1.5x"
                                    ></CheckSquareIcon>
                                    <label class="ml-2 cursor-pointer" @click="changeAutoGenerate">Auto generate</label>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label>Theme</label>
                            <div class="theme-picker d-flex flex-wrap pt-2 mb-4" style="gap: 20px">
                                <div v-for="theme in quiz.themes" :key="theme.name">
                                    <ThemeSelect
                                        @select="onSelectTheme(theme.name)"
                                        @remove="onRemoveTheme"
                                        :active="quiz.theme_name == theme.name"
                                        :theme="theme"
                                        :is-backend="true"
                                    />
                                </div>
                                <div v-if="themesCount < 8" @click="addNewTheme" class="new-theme">
                                    <div class="text-add-new">Add new</div>
                                </div>
                            </div>

                            <div
                                v-if="quiz.themes && quiz.theme_name && quiz.themes[quiz.theme_name]"
                                class="theme-section-backend"
                            >
                                <div class="divider-modal my-3"></div>
                                <ColorContrastWarning
                                    @change-button-and-text-color="
                                        onChangeButtonAndTextColor($event, quiz.themes[quiz.theme_name])
                                    "
                                    @change-background-and-text-color="
                                        onChangeBackgrounAndTextColor($event, quiz.themes[quiz.theme_name])
                                    "
                                    @change-background-and-button-color="
                                        onChangeBackgrounAndButtonColor($event, quiz.themes[quiz.theme_name])
                                    "
                                    :background-color="quiz.themes[quiz.theme_name].background_color"
                                    :text-color="quiz.themes[quiz.theme_name].question_text_color"
                                    :button-color="quiz.themes[quiz.theme_name].button_color"
                                    :button-text-color="quiz.themes[quiz.theme_name].button_text_color"
                                />
                                <div class="d-flex flex-wrap align-items-center">
                                    <div class="label-theme mb-3">
                                        <label class="m-0">Question</label>
                                    </div>
                                    <div class="w-auto d-flex">
                                        <div class="d-flex justify-content-center align-items-center pr-5">
                                            <Swatches
                                                v-model="quiz.themes[quiz.theme_name].question_text_color"
                                                :trigger-style="{
                                                    width: '35px',
                                                    height: '35px',
                                                    border: '2px solid #ccc'
                                                }"
                                                shapes="circles"
                                                colors="text-advanced"
                                                class="cursor-pointer"
                                                show-fallback
                                            />
                                            <span class="pl-2">Text</span>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center">
                                            <Swatches
                                                v-model="quiz.themes[quiz.theme_name].question_shadow_color"
                                                :trigger-style="{
                                                    width: '35px',
                                                    height: '35px',
                                                    border: '2px solid #ccc'
                                                }"
                                                :swatch-style="{
                                                    borderRadius: '0',
                                                    padding: '0',
                                                    margin: '0'
                                                }"
                                                :wrapper-style="{
                                                    padding: '0'
                                                }"
                                                :colors="swatches"
                                                popover-to="center"
                                                shapes="circles"
                                                row-length="8"
                                                swatch-size="24"
                                                class="cursor-pointer"
                                            />
                                            <span class="pl-2">Shadow</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="divider-modal my-3"></div>
                                <div class="d-flex flex-wrap align-items-center">
                                    <div class="label-theme mb-3">
                                        <label class="m-0">Button</label>
                                    </div>
                                    <div class="w-auto d-flex">
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                            style="padding-right: 1.8rem !important"
                                        >
                                            <Swatches
                                                v-model="quiz.themes[quiz.theme_name].button_color"
                                                :trigger-style="{
                                                    width: '35px',
                                                    height: '35px',
                                                    border: '2px solid #ccc'
                                                }"
                                                shapes="circles"
                                                colors="text-advanced"
                                                class="cursor-pointer"
                                                show-fallback
                                            />
                                            <span class="pl-2">Button</span>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center">
                                            <Swatches
                                                v-model="quiz.themes[quiz.theme_name].button_text_color"
                                                :trigger-style="{
                                                    width: '35px',
                                                    height: '35px',
                                                    border: '2px solid #ccc'
                                                }"
                                                shapes="circles"
                                                colors="text-advanced"
                                                class="cursor-pointer"
                                                show-fallback
                                            />
                                            <span class="pl-2">Text</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="divider-modal my-3"></div>
                                <div class="d-flex flex-wrap align-items-center">
                                    <div class="label-theme mb-3">
                                        <label class="m-0">Background</label>
                                    </div>
                                    <div class="w-auto d-flex">
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                            style="padding-right: 2.5rem"
                                        >
                                            <Swatches
                                                v-model="quiz.themes[quiz.theme_name].background_color"
                                                :trigger-style="{
                                                    width: '35px',
                                                    height: '35px',
                                                    border: '2px solid #ccc'
                                                }"
                                                shapes="circles"
                                                colors="text-advanced"
                                                class="cursor-pointer"
                                                show-fallback
                                            />
                                            <span class="pl-2">Color</span>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center">
                                            <UploadPicker
                                                @onUploadImageHandler="onUploadThemeImage"
                                                @onRemoveImageHandler="removeThemeImage"
                                                :path="quiz.themes[quiz.theme_name].background_image"
                                                :image-original="quiz.themes[quiz.theme_name].background_image_original"
                                                :image-source="quiz.themes[quiz.theme_name].background_image_source"
                                                :image-coordinates="
                                                    quiz.themes[quiz.theme_name].background_image_coordinates
                                                "
                                                :background="true"
                                                :quiz-name="'quizTheme'"
                                                :keep-ratio-crop-area="false"
                                                :preview-image-style="'pointer-events: none; border-radius: 50%'"
                                                :prompt-title="quiz.title"
                                                :location="'themebgimage'"
                                                class="theme-img-style"
                                                ref="themeBgImage"
                                            />
                                            <span class="pl-2">Image</span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="quiz.themes[quiz.theme_name].background_image"
                                    class="form-group text-center mt-3"
                                >
                                    <div>
                                        <label>Blur Image</label>
                                        <SliderBar
                                            @change="val => (quiz.background_image_blur = val)"
                                            :id="'bg-image-blur'"
                                            :value="quiz.background_image_blur ? quiz.background_image_blur : 0"
                                            :rangeText="[0, 10]"
                                            :min="0"
                                            :max="10"
                                        />
                                        <label>Image Opacity</label>
                                        <SliderBar
                                            @change="val => (quiz.background_image_opacity = val)"
                                            :id="'bg-image-opacity'"
                                            :value="quiz.background_image_opacity ? quiz.background_image_opacity : 100"
                                            :rangeText="[0, 100]"
                                            :min="0"
                                            :max="100"
                                        />
                                    </div>
                                </div>
                                <div class="divider-modal my-3"></div>
                                <div class="d-flex flex-wrap align-items-center">
                                    <div class="label-theme mb-3">
                                        <label class="m-0">UI Color</label>
                                    </div>
                                    <div class="w-auto">
                                        <Swatches
                                            v-model="quiz.themes[quiz.theme_name].ui_color"
                                            :trigger-style="{
                                                width: '35px',
                                                height: '35px',
                                                border: '2px solid #ccc'
                                            }"
                                            shapes="circles"
                                            colors="text-advanced"
                                            class="cursor-pointer"
                                            show-fallback
                                        />
                                    </div>
                                </div>
                                <!-- <div class="divider-modal"></div> -->
                            </div>
                        </div>

                        <!-- <div class="form-group">
                            <label for="background-music" class="ml-2">Background Music</label>
                            <BgMusicSelect v-model="quiz.background_music" @select="selectBgMusic"></BgMusicSelect>
                        </div>
                        <div
                            v-if="quiz.background_music.name !== 'No Music'"
                            class="form-group d-flex align-items-center"
                        >
                            <div @click="handleBgMusic" class="d-flex align-items-center cursor-pointer sound-btn">
                                <i v-if="!isPlayingMusic" class="fas fa-play bg-music-icon cursor-pointer"></i>
                                <i v-if="isPlayingMusic" class="fas fa-pause bg-music-icon cursor-pointer"></i>
                                <span class="ml-2 pointer-events-none"> Click for sound</span>
                            </div>
                            <div class="ml-2 w-25 mt-3">
                                <SliderBar
                                    @change="updateBgMusicVolume"
                                    :value="quiz.background_music.volume * 10"
                                    :rangeText="[0, 10]"
                                    :min="0"
                                    :max="10"
                                ></SliderBar>
                            </div>
                        </div> -->

                        <div class="divider-modal"></div>

                        <div v-if="quiz.age != undefined && quiz.age" class="form-group">
                            <label>Age Recommended</label>
                            <SliderBar
                                @change="val => (quiz.age = val)"
                                :id="'age-recommend'"
                                :value="quiz.age"
                                :min="0"
                                :max="99"
                            />
                        </div>
                        <div v-if="quiz.difficult != undefined || quiz.difficult != null" class="form-group">
                            <label>Difficult Level</label>
                            <SliderBar
                                @change="val => (quiz.difficult = val)"
                                :id="'difficult-level'"
                                :value="quiz.difficult"
                                :rangeText="['Easy', 'Normal', 'Hard']"
                                :min="0"
                                :max="10"
                            />
                        </div>

                        <div class="divider-modal"></div>

                        <div class="form-group">
                            <label for="category">Tag/Category</label>
                            <span v-if="tagRequired" class="require ml-1">*</span>
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="tagRequired ? 'required' : null"
                                name="Category"
                            >
                                <TagSelect
                                    v-model="quiz.tags"
                                    @input="updateTags"
                                    :tag-list="tagList"
                                    :return-object="true"
                                    :is-taggable="true"
                                    :class="{ 'form-control': true, 'is-invalid': errors[0] }"
                                    id="category"
                                    placeholder="Select or add tag/category"
                                    class="tag-select"
                                ></TagSelect>
                                <span class="invalid-feedback">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label for="category">Exclude Tag/Category</label>
                            <TagSelect
                                v-model="quiz.exclude_tags"
                                @input="updateTags"
                                :tag-list="tagList"
                                :return-object="true"
                                :isTaggable="true"
                                :class="{ 'form-control': true }"
                                id="category"
                                placeholder="Select or add tag/category"
                                rules="required"
                                class="tag-select"
                            ></TagSelect>
                        </div>
                        <div class="form-group">
                            <label>
                                Country
                                <HelpCircleIcon
                                    v-tippy="{ placement: 'right' }"
                                    content="If this field empty this quiz will set access level with global level."
                                    class="text-danger cursor-pointer"
                                    size="1x"
                                />
                            </label>
                            <CountrySelect
                                v-model="quiz.countries"
                                @select="relateCountry"
                                placeholder="Select countries for display quiz"
                            ></CountrySelect>
                        </div>
                        <div class="form-group">
                            <label>
                                Exclude Country
                                <HelpCircleIcon
                                    v-tippy="{ placement: 'right' }"
                                    content="If this field is setted, quiz will not show in these countries."
                                    class="text-danger cursor-pointer"
                                    size="1x"
                                />
                            </label>
                            <CountrySelect
                                v-model="quiz.exclude_countries"
                                @select="relateCountryExclude"
                                placeholder="Select countries for not display quiz"
                            ></CountrySelect>
                        </div>

                        <div v-if="isEdit">
                            <div class="divider-modal"></div>
                            <div class="row">
                                <div class="form-group col-12 col-md-5">
                                    <SquareIcon
                                        v-if="!quiz.show_school_list"
                                        @click="onShowSchoolList"
                                        class="cursor-pointer"
                                        size="1.5x"
                                    ></SquareIcon>
                                    <CheckSquareIcon
                                        v-if="quiz.show_school_list"
                                        @click="onShowSchoolList"
                                        class="cursor-pointer text-success"
                                        size="1.5x"
                                    ></CheckSquareIcon>
                                    <label class="ml-2 cursor-pointer" @click="onShowSchoolList">
                                        Show in school list
                                    </label>
                                </div>
                                <div class="form-group col-12 col-md-5">
                                    <SquareIcon
                                        v-if="!quiz.show_school_country_list"
                                        @click="onShowYourCountry"
                                        class="cursor-pointer"
                                        size="1.5x"
                                    ></SquareIcon>
                                    <CheckSquareIcon
                                        v-if="quiz.show_school_country_list"
                                        @click="onShowYourCountry"
                                        class="cursor-pointer text-success"
                                        size="1.5x"
                                    ></CheckSquareIcon>
                                    <label class="ml-2 cursor-pointer" @click="onShowYourCountry">
                                        Show in your country
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="flex mb-2 sm:mb-0 w-full" v-if="isEdit">
                            <div class="form-group mb-2 pr-1 class-subject-grade">
                                <label> Class subject </label>
                                <XSubjectSelect
                                    @input="
                                        val => {
                                            relateSubject({ target: { name: 'updateClassSubject', value: val } })
                                        }
                                    "
                                    :options="
                                        subjectItems.map(subject => ({ name: subject.name, label: subject.label }))
                                    "
                                    :value="quiz.class_subject"
                                    placeholder="Select subject"
                                    label="name"
                                    class="input input-block input-text-center font-size-17 quiz-dropdown"
                                    name="updateSubject"
                                    dense
                                    outlined
                                ></XSubjectSelect>
                            </div>
                            <div class="form-group mb-2 pl-1 class-subject-grade">
                                <label> Class grade </label>
                                <GradeSelect
                                    v-model="quiz.class_grade"
                                    @select="relateGrade"
                                    class="text-capitalize"
                                    placeholder="Select grade"
                                ></GradeSelect>
                            </div>
                        </div>

                        <div class="divider-modal"></div>

                        <div class="form-group">
                            <label>
                                Set active quiz by date <small><b>(Start date - Expires date)</b></small>
                            </label>
                            <div class="d-flex">
                                <DatePicker
                                    v-model="quiz.start_at"
                                    :disabled-date="disabledAfterExpiresAt"
                                    type="date"
                                    value-type="format"
                                    format="YYYY-MM-DD"
                                    placeholder="Select start date"
                                    class="cursor-pointer mr-2"
                                />
                                <DatePicker
                                    v-model="quiz.expires_at"
                                    :disabled-date="disabledBeforeStartAt"
                                    type="date"
                                    value-type="format"
                                    format="YYYY-MM-DD"
                                    placeholder="Select expires date"
                                    class="cursor-pointer"
                                />
                            </div>
                        </div>

                        <div class="divider-modal"></div>

                        <div class="form-group embed-nav">
                            <div
                                @click="showEmbed = !showEmbed"
                                class="d-flex justify-content-between align-items-center p-3"
                            >
                                <label>Embed Quiz</label>
                                <svg
                                    :style="[showEmbed ? { transform: 'rotate(180deg)' } : '']"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="10"
                                    role="presentation"
                                    class="vs__open-indicator"
                                >
                                    <path
                                        d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                                    ></path>
                                </svg>
                            </div>
                            <EmbedQuiz
                                v-show="showEmbed"
                                @copied="copyLink($event, 'embed')"
                                :quiz="quiz"
                                ref="embedQuiz"
                            />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button :disabled="isAiProcessing" type="button" class="btn btn-secondary" @click="resetModal">
                            Close
                        </button>
                        <button :disabled="isAiProcessing" class="btn btn-success">
                            {{ isEdit ? 'Update' : 'Create' }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import Loader from '@/components/Loader'
import UploadPicker from '@/components/UploadPicker'
import helpers from '@/service/helpers'
import Swatches from 'vue-swatches'
import CountrySelect from '@/components/CountrySelect'
import GradeSelect from '@/components/GradeSelect'
import TagSelect from '@/components/TagSelect'
// import BgMusicSelect from '@/components/BgMusicSelect'
import DatePicker from 'vue2-datepicker'
import InputNumber from '@/components/InputNumber'
import XSubjectSelect from '@/components/XSubjectSelect'
import SliderBar from '@/components/SliderBar'
import EmptyList from '@/components/EmptyList'
import $ from 'jquery'
import { HelpCircleIcon, CheckSquareIcon, SquareIcon } from 'vue-feather-icons'
import { mapGetters } from 'vuex'
import helperMixin from '@/mixins/helper'
import EmbedQuiz from '@/components/EmbedQuiz.vue'
import datalist from '../../../../frontend/src/mixins/datalist'
import ThemeSelect from '../../../../frontend/src/components/quiz-creator/quiz-section/ThemeSelect.vue'
import ColorContrastWarning from '../../../../frontend/src/components/quiz-creator/quiz-section/ColorContrastWarning.vue'
import { defaultThemes } from '../../../../frontend/src/store/util'
import axios from 'axios'
import API_URL from '@/router/api'

export default {
    props: {
        id: {
            type: String,
            default: ''
        },

        show: {
            type: Boolean,
            default: false
        },

        type: {
            type: String,
            default: 'quiz'
        },

        quizId: {
            type: String,
            default: ''
        }
    },

    components: {
        Loader,
        UploadPicker,
        Swatches,
        CountrySelect,
        HelpCircleIcon,
        CheckSquareIcon,
        SquareIcon,
        TagSelect,
        // BgMusicSelect,
        DatePicker,
        InputNumber,
        SliderBar,
        EmptyList,
        EmbedQuiz,
        GradeSelect,
        XSubjectSelect,
        ThemeSelect,
        ColorContrastWarning
    },

    computed: {
        isEdit() {
            return this.quizId != 'new'
        },

        ...mapGetters('tag', {
            tags: 'tags'
        }),

        blur() {
            return this.quiz.background_image_blur
        },

        darken() {
            return this.quiz.background_image_darken
        },

        opacity() {
            return this.quiz.background_image_opacity
        },

        isAiProcessing() {
            return this.isAiGeneratingDescription || this.isAiGeneratingSeoKeyword
        },

        themesCount() {
            return Object.keys(this.quiz.themes).length
        },

        tagRequired() {
            return (
                this.quiz.show_school_list ||
                this.quiz.show_school_country_list ||
                this.quiz.approval_status ||
                this.quiz.admin_approval_status ||
                !this.quiz.user_id
            )
        }
    },

    watch: {
        type(val) {
            this.quizType = val
        },

        show(val) {
            this.isLoading = true
            setTimeout(() => {
                if (val && this.quizId != 'new') {
                    this.fetchQuiz()
                } else {
                    this.isLoading = false
                }
            }, 500)
        },

        blur() {
            document.documentElement.style.setProperty(
                '--bg-image-blur',
                'blur(' + this.quiz.background_image_blur + 'px)'
            )
        },

        darken() {
            document.documentElement.style.setProperty(
                '--bg-image-brightness',
                'brightness(' + (100 - this.quiz.background_image_darken) + '%)'
            )
        },

        opacity() {
            document.documentElement.style.setProperty('--bg-image-opacity', this.quiz.background_image_opacity + '%')
        }
    },

    created() {
        this.fetchTag()
        this.fetchSystemSettings()
    },

    mounted() {
        const colors = []

        for (let key in this.getColors()) {
            colors.push(key)
        }

        this.colors = colors

        $(`#${this.id}`)
            .on('show.bs.modal', () => {
                if (!this.isEdit) {
                    let themes = this.themesSettings

                    if (Object.keys(this.themesSettings).length === 0) {
                        themes = defaultThemes()
                    }

                    this.quiz.theme_name = Object.keys(this.themesSettings)[0] || 'theme_1'
                    this.quiz.themes = themes
                }
            })
            .on('hide.bs.modal', () => {
                if (this.isAiProcessing) {
                    return false
                }

                if (this.audioBg) {
                    this.audioBg.pause(0)
                    this.isPlayingMusic = false
                }
            })
            .on('hidden.bs.modal', () => {
                this.resetModal()
            })
    },

    data() {
        return {
            isShow: false,
            isLoading: true,
            isAiGeneratingDescription: false,
            isAiGeneratingSeoKeyword: false,
            isBackgroundMusic: false,
            audioBg: '',
            isPlayingMusic: false,
            volume: 1,
            quiz: {
                image: null,
                image_placeholder: null,
                image_original: null,
                image_source: null,
                title: null,
                description: null,
                seo_keyword: null,
                custom_message: null,
                is_random_question_order: true,
                background_type: '',
                background_color: '#ef0000',
                background_image: null,
                background_image_original: null,
                background_image_source: null,
                background_image_coordinates: {},
                background_image_blur: 0,
                background_image_darken: 0,
                background_image_opacity: 100,
                background_music: {
                    id: 0,
                    name: 'No Music',
                    src: '',
                    is_playing: '',
                    volume: 0
                },
                type: null,
                status: false,
                created_by: 'admin',
                tags: [],
                exclude_tags: [],
                countries: [],
                exclude_countries: [],
                show_number_question: 10,
                show_result_on_user_device: false,
                limit_player: 10,
                auto_generate: false,
                questions: [],
                show_correct_answer: true,
                start_at: null,
                expires_at: null,
                playalone_auto_start: true,
                difficult: 5,
                age: [0, 99],
                embed: null,
                is_pin_quiz: 0,
                class_subject: [],
                class_grade: [],
                show_school_list: false,
                show_school_country_list: false,
                theme_name: 'theme_1',
                themes: defaultThemes()
            },
            tagList: [],
            colors: null,
            quizType: null,
            showEmbed: false,
            subjectItems: [],
            systemSettings: {},
            themesSettings: {}
        }
    },

    mixins: [helperMixin, datalist],

    methods: {
        ...helpers,

        openUrlQuiz(url) {
            window.open(url, '_blank')
        },

        getSchoolSubject(id) {
            this.$store
                .dispatch('quiz/getSchoolSubjectById', {
                    id: id
                })
                .then(res => {
                    let dataSubjects = res.data.data
                    let subjects = []

                    for (let index in dataSubjects) {
                        if (dataSubjects[index].status) {
                            subjects.push(dataSubjects[index])
                        }
                    }

                    this.subjectItems = subjects
                    this.isLoading = false
                })
                .catch(() => {
                    this.isLoading = false
                })
        },

        getAvailableSchoolSubject() {
            this.$store
                .dispatch('school/getAvailableSchoolSubjects')
                .then(res => {
                    let dataSubjects = res.data.data
                    let subjects = []

                    for (let index in dataSubjects) {
                        if (dataSubjects[index].status) {
                            subjects.push(dataSubjects[index])
                        }
                    }

                    this.subjectItems = subjects
                    this.isLoading = false
                })
                .catch(e => {
                    console.log(e)
                    this.isLoading = false
                })
        },

        async onSubmit() {
            const isValid = await this.validateForm(this.$refs.form)

            if (!isValid) {
                this.scrollToTop(this.$refs.modalBody)
                return false
            }

            let formData = {
                ...this.quiz,
                playing_counter: 0
            }

            this.isLoading = true
            formData.type = this.quizType.toLowerCase()
            formData.background_type = this.quiz.background_type

            if (!this.isEdit) {
                if (!this.quiz.image || this.quiz.image == '') {
                    formData.image_placeholder = this.randomPlaceholderImage()
                }
            }

            if (this.quiz.background_type !== '' && this.quiz.background_type === 'color') {
                formData.background_color = this.quiz.background_color
            }
            if (this.quiz.background_type !== '' && this.quiz.background_type === 'image') {
                formData.background_image = this.quiz.background_image
            }

            if (this.quiz.background_music.name == 'No Music') {
                this.$set(formData.background_music, 'name', '')
            }

            formData.tags = formData.tags.map(item => {
                return item.code
            })

            if (formData.exclude_tags) {
                formData.exclude_tags = formData.exclude_tags.map(item => {
                    return item.code
                })
            }

            if (this.isEdit) {
                const activeQuestions = formData.questions.filter(question => question.status).length

                if (formData.auto_generate === false && !activeQuestions) {
                    formData = {
                        ...formData,
                        status: false
                    }
                }

                return this.$store
                    .dispatch('quiz/update', {
                        id: this.quizId,
                        form: formData
                    })
                    .then(res => {
                        this.isLoading = false
                        window.shout.success('Update quiz success')
                        this.$emit('submit', res)
                        this.resetModal()
                    })
                    .catch(err => {
                        this.isLoading = false
                        window.shout.error('Update quiz fail')

                        if (err.response.status == 422) {
                            const errors = err.response.data.data

                            this.$refs.form.setErrors(errors)
                        }
                    })
            }

            this.$store
                .dispatch('quiz/create', formData)
                .then(res => {
                    this.isLoading = false
                    window.shout.success('Create Quiz Success.')
                    this.$emit('submit', res)
                    this.resetModal()
                })
                .catch(err => {
                    this.isLoading = false
                    window.shout.error('Create Quiz Fail !')

                    if (err.response.status == 422) {
                        const errors = err.response.data.data

                        this.$refs.form.setErrors(errors)
                    }
                })
        },

        fetchQuiz() {
            const self = this

            self.$store.dispatch('quiz/findById', self.quizId).then(res => {
                self.$set(self, 'quiz', Object.assign({}, self.quiz, res.data.data))

                self.quiz.show_number_question = Number(self.quiz.show_number_question)

                self.quiz.tags = self.tagList.filter(tag => Array(...self.quiz.tags).indexOf(tag.code) > -1)

                self.quiz.exclude_tags = self.tagList.filter(
                    tag => Array(...self.quiz.exclude_tags).indexOf(tag.code) > -1
                )

                self.quizType = self.quiz.type
                self.isLoading = false

                if (self.quiz.created_by == 'user' && typeof res.data.data.is_random_question_order == 'undefined') {
                    self.quiz.is_random_question_order = false
                }

                if (self.quiz.background_music.name == '') {
                    self.$set(self.quiz.background_music, 'name', 'No Music')
                }

                if (self.quiz.background_music.volume != 0) {
                    self.volume = self.quiz.background_music.volume
                }
                if (self.quiz.background_music.src !== '') {
                    self.setAudioBgSrc()
                }

                if (!self.quiz.status) {
                    self.quiz.url = new URL(self.quiz.url)
                    self.quiz.url.searchParams.append('mode', 'preview')
                }

                self.getEmbed()

                //level of teacher
                if (self.quiz.user && (self.quiz.user.role == 'teacher' || self.quiz.user.role == 'teacher_plus')) {
                    self.getSchoolSubject(self.quiz.user_id)
                } else {
                    self.getAvailableSchoolSubject()
                }

                if (self.quiz.background_image_blur) {
                    document.documentElement.style.setProperty(
                        '--bg-image-blur',
                        'blur(' + self.quiz.background_image_blur + 'px)'
                    )
                }

                if (self.quiz.background_image_darken) {
                    document.documentElement.style.setProperty(
                        '--bg-image-brightness',
                        'brightness(' + (100 - self.quiz.background_image_darken) + '%)'
                    )
                }

                if (self.quiz.background_image_opacity) {
                    document.documentElement.style.setProperty(
                        '--bg-image-opacity',
                        self.quiz.background_image_opacity + '%'
                    )
                }
            })
        },

        fetchSystemSettings() {
            axios.get(API_URL.setting.getSetting).then(res => {
                const setting = res.data.data
                this.themesSettings = setting.themes ? setting.themes.content : {}
                this.systemSettings = {
                    question_text_color: setting.text_color.content,
                    question_shadow_color: setting.text_shadow_color.content,
                    button_text_color: setting.button_text_color.content,
                    button_color: setting.button_color.content,
                    ui_color: setting.ui_primary_color.content,
                    background_color: setting.background_color.content
                }
            })
        },

        fetchTag() {
            this.quizType = this.type

            this.$store.dispatch('tag/list', { type: 'quiz' }).then(res => {
                const tags = res.data.data.data.map(tag => {
                    return {
                        label: tag.name,
                        code: tag._id.$oid,
                        type: tag.type
                    }
                })

                this.tagList = tags
            })
        },

        onUploadImageQuiz(img, original, source, coordinates) {
            this.quiz.image = img
            this.quiz.image_original = original
            this.quiz.image_source = source || ''
            this.quiz.image_coordinates = coordinates
        },

        relateCountry(value) {
            this.quiz.countries = value
        },

        relateGrade(value) {
            this.quiz.class_grade = value
        },

        relateSubject(e) {
            var value = e.target.value
            this.quiz.class_subject = value
        },

        relateCountryExclude(value) {
            this.quiz.exclude_countries = value
        },

        setAudioBgSrc() {
            let baseUrl = process.env.VUE_APP_API_BASE_URL
            baseUrl = baseUrl.replace('/admin/api', '/')
            let fullUrl = baseUrl + this.quiz.background_music.src
            this.audioBg = document.getElementById('audioBgSrc')
            this.audioBg.setAttribute('src', fullUrl)
            this.audioBg.volume = this.quiz.background_music.volume
        },

        selectBgMusic(value) {
            if (value.name == 'No Music') {
                value.name == ''
            }
            value.volume = this.volume
            this.quiz.background_music = value
            if (this.quiz.background_music.src !== '') {
                this.setAudioBgSrc()
            }
            this.isPlayingMusic = false
            if (this.audioBg) {
                this.audioBg.pause(0)
            }
        },

        handleBgMusic() {
            this.isPlayingMusic = !this.isPlayingMusic
            if (this.isPlayingMusic) {
                this.audioBg.play()
            } else {
                this.audioBg.pause(0)
            }
        },

        updateBgMusicVolume(value) {
            this.volume = value / 10
            this.quiz.background_music.volume = this.volume
            this.audioBg.volume = this.volume
        },

        onChangeBackgroundColorHandler(value) {
            this.quiz.background_color = value
        },

        onUploadImageQuizBackground(img, original, source, coordinates) {
            this.quiz.background_image = img
            this.quiz.background_image_original = original
            this.quiz.background_image_source = source
            this.quiz.background_image_coordinates = coordinates
            if (source) {
                this.quiz.background_image_source = source
            }
        },

        changeAutoGenerate() {
            this.quiz.auto_generate = !this.quiz.auto_generate
        },

        changeShowCorrectAnswer() {
            this.quiz.show_correct_answer = !this.quiz.show_correct_answer
        },

        checkBackgroundMusic() {
            this.isBackgroundMusic = !this.isBackgroundMusic
        },

        changePlayaloneAutostart() {
            this.quiz.playalone_auto_start = !this.quiz.playalone_auto_start
        },

        changeRandomQuestion() {
            this.quiz.is_random_question_order = !this.quiz.is_random_question_order
        },

        changePinQuiz() {
            if (this.quiz.is_pin_quiz === 0) {
                this.quiz.is_pin_quiz = 1
            } else {
                this.quiz.is_pin_quiz = 0
            }
        },

        updateTags(tags) {
            for (let i in tags) {
                if (typeof tags[i].label === 'undefined') {
                    let tag = this.tagList.filter(item => {
                        return item.label === tags[i]
                    })
                    if (tag.length > 0) {
                        let oldTagSelect = tags.filter(item => {
                            return item.label === tag[0].label
                        })

                        if (oldTagSelect.length === 0) {
                            tags[i] = tag[0]
                        } else {
                            tags.splice(i, 1)
                        }
                    } else {
                        let formData = {
                            name: tags[i],
                            type: 'quiz',
                            color: '#ef0000'
                        }

                        tags[i] = {
                            label: tags[i],
                            code: '',
                            type: 'quiz'
                        }

                        this.$store
                            .dispatch('tag/create', [formData])
                            .then(res => {
                                let tag = res.data.data[0]
                                tags[i].code = tag._id.$oid
                            })
                            .catch(err => {
                                console.log(err)
                            })
                    }
                }
            }
        },

        resetModal() {
            if (this.quizId == 'new') {
                this.quiz = {
                    image: null,
                    image_source: null,
                    title: null,
                    description: null,
                    custom_message: null,
                    background_type: '',
                    background_color: '#ef0000',
                    background_image: null,
                    background_image_source: null,
                    background_image_blur: 0,
                    background_image_darken: 0,
                    background_image_opacity: 100,
                    background_music: {
                        id: 0,
                        name: 'No Music',
                        src: '',
                        is_playing: '',
                        volume: 0
                    },
                    type: null,
                    status: false,
                    created_by: 'admin',
                    tags: [],
                    countries: [],
                    exclude_countries: [],
                    show_number_question: 10,
                    show_result_on_user_device: false,
                    limit_player: 10,
                    auto_generate: false,
                    questions: [],
                    show_correct_answer: true,
                    is_random_question_order: true,
                    start_at: null,
                    expires_at: null,
                    playalone_auto_start: true,
                    difficult: 5,
                    age: [0, 99],
                    embed: null,
                    class_subject: null,
                    class_grade: [],
                    show_school_list: false,
                    show_school_country_list: false,
                    theme_name: 'theme_1',
                    themes: defaultThemes()
                }
            }

            document.documentElement.style.setProperty('--bg-image-blur', `blur(0)`)
            document.documentElement.style.setProperty('--bg-image-brightness', `brightness(1)`)
            document.documentElement.style.setProperty('--bg-image-opacity', `100%`)

            if (this.audioBg) {
                this.audioBg.pause(0)
            }

            this.$emit('close')
            $(`#${this.id}`).modal('hide')
        },

        disabledBeforeStartAt(date) {
            const startDate = this.quiz.start_at ? new Date(this.quiz.start_at) : null

            if (startDate) {
                return date < startDate
            }

            return false
        },

        disabledAfterExpiresAt(date) {
            const expiresDate = this.quiz.expires_at ? new Date(this.quiz.expires_at) : null

            if (expiresDate) {
                return date > expiresDate
            }

            return false
        },

        async getEmbed() {
            let embedData = await this.$store.dispatch('quiz/getEmbed', { id: this.quiz._id })
            if (embedData.status === 200) {
                this.$refs.embedQuiz.setEmbedData(embedData.data.data)
            } else {
                console.error('get embed failed')
            }
        },

        copyLink(url, type) {
            url = url || window.shareLink

            if (window.navigator.share) {
                navigator.share({
                    title: 'TheBigQuiz',
                    text: `${window.siteTitle} - TheBigQuiz`,
                    url: url
                })
            } else {
                navigator.clipboard
                    .writeText(url)
                    .then(() => {
                        if (type != 'embed') {
                            window.shout.success('Link is copied, share it on mail, chat etc.')
                        } else {
                            window.shout.success('Embed code is copied')
                        }
                    })
                    .catch(() => {
                        if (type != 'embed') {
                            window.shout.error('Your browser not support copy to clipboard')
                        } else {
                            window.shout.error('Your browser not support copy to clipboard')
                        }
                    })
            }
        },

        onShowSchoolList() {
            this.quiz.show_school_list = !this.quiz.show_school_list
        },

        onShowYourCountry() {
            this.quiz.show_school_country_list = !this.quiz.show_school_country_list
        },

        async generateAiDescription() {
            this.isAiGeneratingDescription = true

            try {
                const res = await this.$store.dispatch('quiz/generateAiDescription', {
                    title: this.quiz.title
                })
                this.quiz.description = res.data.data.description
                window.shout.success('Generate quiz description success')
            } catch {
                window.shout.error('AI not available to generate quiz now, please try again')
            }

            this.isAiGeneratingDescription = false
        },

        async generateAiSeoKeyword() {
            this.isAiGeneratingSeoKeyword = true

            try {
                const res = await this.$store.dispatch('quiz/generateQuizSeoKeyword', {
                    title: this.quiz.title,
                    length: 10
                })

                this.quiz.seo_keyword = res.data.data.keywords.join(', ')
                window.shout.success('Generate SEO keyword success')
            } catch {
                window.shout.error('AI not available to generate SEO keyword, please try again')
            }

            this.isAiGeneratingSeoKeyword = false
        },

        onSelectTheme(name) {
            this.quiz.theme_name = name
        },

        removeThemeImage() {
            this.quiz.themes[this.quiz.theme_name].background_image = ''
            this.quiz.themes[this.quiz.theme_name].background_image_source = ''
            this.quiz.themes[this.quiz.theme_name].background_image_original = ''
            this.quiz.themes[this.quiz.theme_name].background_image_coordinates = {}
            this.quiz.background_image_blur = 0
            this.quiz.background_image_darken = 0
            this.quiz.background_image_opacity = 100
        },

        onUploadThemeImage(img, original, source, coordinates) {
            this.quiz.themes[this.quiz.theme_name].background_image = img
            this.quiz.themes[this.quiz.theme_name].background_image_source = source
            this.quiz.themes[this.quiz.theme_name].background_image_original = original
            this.quiz.themes[this.quiz.theme_name].background_image_coordinates = coordinates
        },

        onRemoveTheme(theme) {
            delete this.quiz.themes[theme.name]
            this.quiz.themes = { ...this.quiz.themes }
        },

        addNewTheme() {
            const keys = Object.keys(this.quiz.themes)
            const lastThemeKey = keys[keys.length - 1] || 'theme_1'
            const lastThemeNumber = Number(lastThemeKey.split('_')[1])
            const newThemeNumber = lastThemeNumber + 1
            const newThemeKey = `theme_${newThemeNumber}`

            const defaultTheme = { ...defaultThemes().theme_1, ...this.systemSettings }
            defaultTheme.name = newThemeKey
            this.quiz.themes = { ...this.quiz.themes, [newThemeKey]: defaultTheme }
        },

        onChangeButtonAndTextColor({ buttonColor, buttonTextColor }, theme) {
            theme['button_color'] = buttonColor
            theme['button_text_color'] = buttonTextColor
        },

        onChangeBackgrounAndTextColor({ backgroundColor, textColor }, theme) {
            theme['background_color'] = backgroundColor
            theme['question_text_color'] = textColor
        },

        onChangeBackgrounAndButtonColor({ backgroundColor, buttonColor }, theme) {
            theme['background_color'] = backgroundColor
            theme['button_color'] = buttonColor
        },

        async cropBackground(image) {
            image = image.replace(':8001', '')

            //hack create dom
            const dom = document.createElement('div')
            dom.setAttribute('data-img', image)
            dom.setAttribute('data-source', image)
            dom.setAttribute('data-thumbnail', image)

            const obj = {
                target: dom
            }

            this.$refs.themeBgImage.isShowModal = true

            await this.$nextTick()

            this.$refs.themeBgImage.$refs.openAsUpload.cropTab = true

            this.$refs.themeBgImage.$refs.openAsUpload.selectExternalImage(obj)
        }
    }
}
</script>

<style lang="scss">
.require {
    color: #dc3545;
}

.vue-swatches__check__wrapper {
    position: absolute;
    width: 42px;
    height: 42px;
}

.vue-swatches--has-children-centered {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
    -ms-flex-pack: center;
    -webkit-box-pack: center;
    justify-content: center;
}

.vue-swatches__check__circle {
    position: absolute;
    width: 21px;
    height: 21px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.15);
}

.bg-music-icon {
    font-size: 1.25rem;
    color: #fff;
}

.sound-btn {
    color: #fff;
    background-color: #dc3545;
    padding: 0.25rem;
    border: 1px solid #dc3545;
    border-radius: 4px;
    width: fit-content;
    transition: background-color 0.5s;
}

.sound-btn:hover {
    background-color: #ad1f2d;
}

.embed-nav {
    width: 100%;
    border-radius: 0.75rem;
    box-shadow: 0 0 10px rgba(66, 66, 66, 0.15);
    cursor: pointer;

    svg {
        transition: transform 0.3s;
    }

    label {
        margin-bottom: 0;
    }
}

.theme-dark-mode .embed-nav {
    background-color: #383838;
}

.class-subject-grade {
    width: 50%;
    display: inline-block;
}

.custom-readonly.form-control:disabled,
.form-control[readonly] {
    background-color: #efefef;
}

.divider-modal {
    border-bottom: 1px solid #ced4da;
    margin: 30px 0 30px 0;
}

.theme-dark-mode .divider-modal {
    border-bottom: 2px solid #e9ecef;
}

.theme-dark-mode {
    .theme-image-picker .image-selection .remove-image-icon {
        i {
            color: #fff !important;
        }
    }
}

.theme-picker {
    .new-theme {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 66px;
        height: 66px;
        border-radius: 50%;
        border: 3px dashed #ccc;
        cursor: pointer;

        .text-add-new {
            text-align: center;
            color: #ccc;
            font-size: 14px;
            word-spacing: 4px;
        }
    }
}

.theme-section-backend {
    .label-theme {
        width: 18%;

        @media screen and (max-width: 768px) {
            width: 33%;
        }
    }

    .theme-image-picker .image-selection .remove-image-icon {
        position: absolute;
        height: 0;

        i {
            font-size: 1.2rem !important;
            color: #000;
        }
    }

    .theme-image-picker .image-selection .image {
        width: 100%;
        height: 100%;
        background-size: cover;
        border-radius: 100%;
    }

    .vue-swatches__check__wrapper {
        position: absolute;
        width: 25px;
        height: 25px;
        fill: #fff;
    }

    .vue-swatches__fallback__wrapper {
        padding-top: 6px;
    }

    .vue-swatches__fallback__input {
        height: 30px;
        font-size: 14px;
    }

    .vue-swatches__fallback__button {
        font-size: 13px;
    }

    .vue-swatches__container:not(.vue-swatches--inline) {
        background-color: rgb(255, 255, 255) !important;
        box-shadow: 0 2px 3px hsla(0, 0%, 4%, 0.2), 0 0 0 1px hsla(0, 0%, 4%, 0.2);
    }

    /* custom upload picker as theme img picker */
    .theme-img-style {
        width: 35px !important;
        height: 35px !important;
        border-radius: 50% !important;
        border: 2px solid rgb(204, 204, 204) !important;
        overflow: unset !important;

        .img-bg {
            border: none !important;
            border-radius: 50% !important;
        }

        label {
            .text-placeholder {
                display: none !important;
            }
        }

        .tool-icon.source-edit {
            width: 100% !important;
            height: 100% !important;
            bottom: 0 !important;
            right: 0 !important;
            border: none !important;

            i {
                display: none !important;
            }
        }

        .close {
            background-color: rgb(0, 0, 0) !important;
            top: -10px !important;
            right: -8px !important;
            width: 20px !important;
            height: 20px !important;
        }

        .loader-wrapper {
            min-height: auto !important;
            width: 35px !important;
            height: 35px !important;
            border-radius: 50% !important;

            .lds-ring {
                width: 35px !important;
                height: 35px !important;

                div {
                    width: 25px !important;
                    height: 25px !important;
                    margin: 3.3px !important;
                    border-width: 3.5px !important;
                }
            }
        }
    }
}
</style>
